import { render, staticRenderFns } from "./SubscribeToProduct.vue?vue&type=template&id=25fbf493&scoped=true"
import script from "./SubscribeToProduct.vue?vue&type=script&lang=js"
export * from "./SubscribeToProduct.vue?vue&type=script&lang=js"
import style0 from "./SubscribeToProduct.vue?vue&type=style&index=0&id=25fbf493&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbf493",
  null
  
)

export default component.exports